// extracted by mini-css-extract-plugin
export var download_icon = "press_kit_section-module--download_icon--3023c";
export var press_kit_button = "press_kit_section-module--press_kit_button--b3d96";
export var press_kit_button_text = "press_kit_section-module--press_kit_button_text--a1a3f";
export var section_press_kit = "press_kit_section-module--section_press_kit--4c1c9";